Object.defineProperty(exports, "__esModule", {
    value: true
});
var Events = {
    READY: "ready",
    RENDER: "render",
    SLOT_RENDER_ENDED: "slotRenderEnded",
    IMPRESSION_VIEWABLE: "impressionViewable",
    SLOT_VISIBILITY_CHANGED: "slotVisibilityChanged"
};

exports.default = Events;


//////////////////
// WEBPACK FOOTER
// ../~/react-gpt/lib/Events.js
// module id = 340
// module chunks = 0